import { ihm_viewer__dictionary, locale } from "Application/i18n/i18nViewer";
import { usePlayer } from "Ui/Layer/hooks/usePlayer";
import { useSelector } from "react-redux";
import { pauseAnimation } from "Ui/Layer/utils/animationState";

export { pauseAnimation };

/**
 * Compact Player — bottom-left, touch-friendly.
 * Shows only: play/pause, prev/next frame, current step / total steps.
 */
export const CompactPlayer = () => {
    const animationState = useSelector((s) => s.AnimationReducer);
    const times = {
        times: animationState.times,
        treatmentPlanning: animationState.metas.treatmentPlanning,
    };
    const { increment, nbMaxi, nbMandi } = animationState;

    const {
        playing,
        keyFrame,
        isSceneLoaded,
        displayable,
        hasAnimation,
        treatmentPlanningCounter,
        togglePlay,
        changeFrame,
        prevFrame,
        nextFrame,
        maxSteps,
    } = usePlayer(times);

    if (displayable !== "flex" || !hasAnimation) {
        return null;
    }

    const playerIsHidden = !isSceneLoaded;
    const currentStep = parseInt(keyFrame, 10);
    const hasNoIncrement = increment === 0;
    const upperDisplay = treatmentPlanningCounter.upper === 0 ? 0 : hasNoIncrement ? treatmentPlanningCounter.upper : nbMaxi;
    const lowerDisplay = treatmentPlanningCounter.lower === 0 ? 0 : hasNoIncrement ? treatmentPlanningCounter.lower : nbMandi;

    return (
        <nav
            id="CompactPlayer"
            style={{ display: displayable }}
            className={`glass-panel${playerIsHidden ? " hidden" : ""}`}
        >
            <button
                className="cp-btn cp-prev"
                onClick={() => changeFrame(prevFrame(keyFrame))}
                aria-label="Previous frame"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6" />
                </svg>
            </button>

            <button
                className="cp-btn cp-play"
                onClick={togglePlay}
                aria-label={playing ? "Pause" : "Play"}
            >
                {playing ? (
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <rect x="6" y="4" width="4" height="16" rx="1" />
                        <rect x="14" y="4" width="4" height="16" rx="1" />
                    </svg>
                ) : (
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8 5v14l11-7z" />
                    </svg>
                )}
            </button>

            <button
                className="cp-btn cp-next"
                onClick={() => changeFrame(nextFrame(keyFrame))}
                aria-label="Next frame"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6" />
                </svg>
            </button>

            <div className="cp-step-info">
                <span className="cp-step-current">{currentStep}</span>
                <span className="cp-step-sep">/</span>
                <span className="cp-step-total">{maxSteps}</span>
            </div>

            <div className="cp-tp-info">
                <span>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.UPPER[locale()]}: {upperDisplay}</span>
                <span>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.LOWER[locale()]}: {lowerDisplay}</span>
            </div>
        </nav>
    );
};
